import { defineKey } from '@ha/intl';

export enum AffiliateCitiesHA {
  Rotterdam = 'Rotterdam',
  Utrecht = 'Utrecht',
}

export const AffiliateCitiesHATitleTranslations: Record<
  AffiliateCitiesHA,
  string
> = {
  [AffiliateCitiesHA.Rotterdam]: defineKey(
    'LBL_SEARCH_HA_BLOCK_TITLE_ROTTERDAM',
  ),
  [AffiliateCitiesHA.Utrecht]: defineKey('LBL_SEARCH_HA_BLOCK_TITLE_UTRECHT'),
};

export const AffiliateCitiesHASubtitleTranslations: Record<
  AffiliateCitiesHA,
  string
> = {
  [AffiliateCitiesHA.Rotterdam]: defineKey(
    'LBL_SEARCH_HA_BLOCK_SUBTITLE_ROTTERDAM',
  ),
  [AffiliateCitiesHA.Utrecht]: defineKey(
    'LBL_SEARCH_HA_BLOCK_SUBTITLE_UTRECHT',
  ),
};

export const AffiliateCitiesHACTATranslations: Record<
  AffiliateCitiesHA,
  string
> = {
  [AffiliateCitiesHA.Rotterdam]: defineKey('LBL_SEARCH_HA_BLOCK_CTA_ROTTERDAM'),
  [AffiliateCitiesHA.Utrecht]: defineKey('LBL_SEARCH_HA_BLOCK_CTA_UTRECHT'),
};
